module.exports = __webpack_public_path__ + "img/stadistic_bars.182cf800.svg";